<template>
    <b-modal id="importar-contrato-modal" size="lg" centered header-bg-variant="secondary" header-text-variant="light"
        title="Importar contratos" hide-footer @hidden="$emit('fecharModal')" :no-close-on-esc="isLoading"
        :no-close-on-backdrop="isLoading" :hide-header-close="isLoading">
        <b-row>
            <b-col cols="12" sm="9">
                <b-form-group id="arquivo-input-group" label="" label-for="input-arquivo" label-cols="auto">
                    <b-form-file v-model="arquivo" placeholder="Escolha o arquivo XML (zipado)" :disabled="isLoading"
                        drop-placeholder="Solte o arquivo aqui" browse-text="..." accept=".zip"></b-form-file>
                </b-form-group>
            </b-col>
            <b-col cols="12" sm="3" class="text-center">
                <b-button @click="enviarArquivo" :disabled="isLoading || !arquivo">
                    <b-spinner small v-if="isLoading" class="mr-1"></b-spinner>
                    <font-awesome-icon v-else icon="cloud-upload" />
                    Enviar
                </b-button>
            </b-col>
        </b-row>
        <b-row v-if="retornoImportacoes" class="mt-1 px-2">
            <b-card no-body :header-bg-variant="retornoImportacoes.corSituacao()"
                :border-variant="retornoImportacoes.corSituacao()" header-text-variant="white"
                :header="`Importações realizadas para ${retornoImportacoes.nomeArquivo}`">
                <div id="importcardwrapper" class="p-3">
                    <CardFiltrosBusca v-if="retornoImportacoes.erros"
                        :titulo="`Erros encontrados (${retornoImportacoes.erros.length})`" border="danger" class="mb-2">
                        <ul>
                            <li v-for="err in retornoImportacoes.erros.slice(0, 4)" :key="err">{{ err }}</li>
                        </ul>
                        <div class="d-flex justify-content-center my-2">
                            <btn-download :fazerDownload="baixarRelatorioErros" texto="Relatório de erros" botao />
                        </div>
                    </CardFiltrosBusca>
                    <b-card v-if="retornoImportacoes.houveImportacao()" no-body border-variant="success"
                        header="Contratos que foram importados">
                        <b-table :fields="fields" hover no-border-collapse striped
                            :items="retornoImportacoes.contratosImportados" stacked="md">
                        </b-table>
                    </b-card>
                    <b-card v-if="retornoImportacoes.houveNaoImportacao()" no-body border-variant="danger"
                        header="Contratos que NÃO foram importados">
                        <b-table :fields="fields" hover no-border-collapse striped
                            :items="retornoImportacoes.contratosNaoImportados" stacked="md">
                        </b-table>
                    </b-card>
                </div>
            </b-card>
        </b-row>
    </b-modal>
</template>

<script lang="ts">
import contratoService from '@/services/licitacoes/contratoService'
import { fieldsImportacao } from '@/types/licitacoes/contratos/fields-contratos';
import { RetornoImportarContratos } from '@/types/licitacoes/contratos/retornos/retorno-importar-contratos'
import { TableField } from '@/types/table-field';
import { UtilsTS } from '@/utilsts'
import { mixins } from 'vue-class-component'
import { Component, Vue } from 'vue-property-decorator'
import BtnDownload from '@/components/shared/btn-download.vue'
import CardFiltrosBusca from '@/components/shared/CardFiltrosBusca.vue';

const CompProps = Vue.extend({
    name: 'ModalImportarContrato',
    components: { BtnDownload, CardFiltrosBusca },
    props: {}
})

@Component
export default class ModalImportarContrato extends mixins(UtilsTS, CompProps) {
    fields: TableField[] = fieldsImportacao
    arquivo: File | null = null
    isLoading = false
    retornoImportacoes: RetornoImportarContratos | null = null

    async mounted() {
        this.$bvModal.show("importar-contrato-modal");
    }

    async enviarArquivo() {
        try {
            this.isLoading = true
            if (!this.arquivo) return this.$toast.error('Arquivo não selecionado')
            const response = await contratoService.importarContratos(this.arquivo)
            this.retornoImportacoes = response
            this.retornoImportacoes.nomeArquivo = this.arquivo.name
            this.arquivo = null
            // console.log('modalimportarlicitacao.enviarArquivo', response)
            if (this.retornoImportacoes.houveImportacao())
                this.$emit('refresh', this.retornoImportacoes?.contratosImportados)
        } catch (error: any) {
            this.tratarError(error)
        } finally {
            this.isLoading = false
        }
    }

    async baixarRelatorioErros() {
        if (this.retornoImportacoes) {
            try {
                const response = await contratoService.baixarRelatorioInconsistencias(this.retornoImportacoes)
                this.download('rel-erros-contratos.pdf', response)
            } catch (error: any) {
                this.tratarError(error)
            }
        }
    }
}
</script>

<style scoped>
:deep(label.custom-file-label::after) {
    display: none;
}
</style>